<template>
<div></div>
</template>
<script>
export default {
    mounted() {
        window.localStorage.removeItem('Admin_token');
        let params = {
            // device_id: localStorage.getItem('device_id')
        }

        this.$store.dispatch('auth/logout' , params)
        .then(() => {
            window.location.replace(this.$url('login'))
        }).catch(error => {
            window.location.replace(this.$url('login'))
        })
    }
}
</script>